var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeAutoObservable, reaction, runInAction } from 'mobx';
import { livequeueConsultationService } from 'ziphy-web-shared/basic/api';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { getTelehealthAppointmentId } from '@nedoShared/modules/dashboard/dashboard.helper';
import { prepareEvents } from '@ps/helpers/events';
import { mediaAuthService } from '@ps/services/mediaAuthService';
import psService from '@ps/services/psService';
import psResourcesStore from '@ps/store/psResourcesStore';
class LivequeueConsultationsStore {
    constructor() {
        this.activeConsultations = [];
        this.createdConsultation = {};
        this.selectedConsultation = {};
        this.consultationsList = [];
        this.attachmentsInProgress = {};
        this.isStatusUpdating = false;
        this.servicesListAll = {};
        this.statusError = null;
        this.documentsEvents = [];
        makeAutoObservable(this);
        reaction(() => ({
            isLogged: $auth.isLogged,
            roleId: $auth.currentRoleId,
        }), ({ isLogged, roleId }) => __awaiter(this, void 0, void 0, function* () {
            if (isLogged && roleId) {
                yield this.getActiveConsultations();
            }
        }), { fireImmediately: true });
    }
    clearStatusError() {
        this.statusError = null;
    }
    getActiveConsultations() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.searchConsultations({
                provider_role_ids: [$auth.currentRoleId],
                statuses: ['in_progress', 'created'],
                limit: 1000,
            });
            runInAction(() => {
                this.activeConsultations = res.results;
            });
            return res;
        });
    }
    loadDocumentsForSelectedConsultation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const sc = this.selectedConsultation;
            const patientId = (_a = sc === null || sc === void 0 ? void 0 : sc.patient) === null || _a === void 0 ? void 0 : _a.id;
            const practiceId = sc.practice_ids[0];
            const appointmentId = getTelehealthAppointmentId(sc.attachments);
            if (!patientId || !practiceId) {
                runInAction(() => (this.documentsEvents = []));
                return [];
            }
            yield mediaAuthService({ patientId, practiceId }).fetch([], { force: true });
            const res = yield psService.searchDocumentsForAppt({ appointmentId });
            const eventHistory = res === null || res === void 0 ? void 0 : res.prepared.eventHistory;
            const preparedEvents = prepareEvents(eventHistory);
            yield psResourcesStore.getResources({ items: preparedEvents, practiceId, patientId }, false);
            runInAction(() => (this.documentsEvents = preparedEvents));
            // if (eventHistory) {
            //   const references = eventHistory.map(getReferenceId)
            //   const res = await psService.getResourcesByReferences({ patientId, practiceId, references })
            //   if (res) {
            //     const resources = res?.prepared.resources
            //     const extrResources = resources.map(resourceExtractor)
            //     runInAction(() => {
            //       this.documentsEvents = resources
            //       this.extractedResources = extrResources
            //     })
            //   }
            // }
            return eventHistory;
        });
    }
    clearSelectedConsultation() {
        this.selectedConsultation = {};
    }
    getConsultationById(consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.getConsultationById(consultationId);
            runInAction(() => {
                this.selectedConsultation = res;
                this.consultationsList = this.consultationsList.map((consultation) => {
                    if (consultation._id === consultationId) {
                        return res;
                    }
                    return consultation;
                });
            });
            yield this.loadDocumentsForSelectedConsultation();
            return res;
        });
    }
    updateConsultation(consultationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.updateConsultation(consultationId, payload);
            runInAction(() => {
                this.selectedConsultation = res;
            });
            return res;
        });
    }
    findConsultations(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.searchConsultations(payload);
            runInAction(() => {
                this.consultationsList = res.results;
            });
            return res;
        });
    }
    // async assignConsultation(consultationId: string, payload: AssignConsultationPayload) {
    //   const res: Consultation = await livequeueConsultationService.assignConsultation(
    //     consultationId,
    //     payload,
    //   )
    //   runInAction(() => {
    //     this.selectedConsultation = res
    //   })
    // }
    updateConsultationStatus(consultationId, newStatus, consultation) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isStatusUpdating = true;
            this.statusError = null;
            try {
                switch (newStatus) {
                    // case 'in_progress':
                    //   await this.startConsultation(consultationId)
                    //   break
                    case 'completed':
                        yield this.completeConsultation(consultationId);
                        break;
                    case 'canceled':
                        yield this.cancelConsultation(consultationId);
                        break;
                    // case 'on_hold':
                    //   await this.holdNextConsultation(consultationId)
                    //   break
                }
            }
            catch (error) {
                runInAction(() => {
                    if (error instanceof Error) {
                        this.statusError = error;
                    }
                    else {
                        this.statusError = new Error(String(error));
                    }
                });
            }
            finally {
                yield this.getActiveConsultations();
                runInAction(() => {
                    this.isStatusUpdating = false;
                });
            }
        });
    }
    completeConsultation(consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.completeConsultation(consultationId);
            runInAction(() => {
                this.selectedConsultation = res;
            });
        });
    }
    cancelConsultation(consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.cancelConsultation(consultationId);
            runInAction(() => {
                this.selectedConsultation = res;
            });
        });
    }
    // async holdNextConsultation(consultationId: string) {
    //   const res: Consultation = await livequeueConsultationService.holdNextConsultation()
    //   runInAction(() => {
    //     this.selectedConsultation = res
    //   })
    // }
    // async startConsultation(consultationId: string) {
    //   const res: Consultation = await livequeueConsultationService.startConsultation(consultationId)
    //   runInAction(() => {
    //     this.selectedConsultation = res
    //   })
    // }
    uploadConsultationAttachments(consultationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.uploadAttachments(consultationId, payload);
            runInAction(() => {
                this.attachmentsInProgress = res;
            });
        });
    }
    confirmAttachmentUpload(uploadRecordId, consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.confirmAttachmentsUpload(uploadRecordId, consultationId);
            runInAction(() => {
                const consultation = this.consultationsList.find((c) => c._id === consultationId);
                if (!consultation) {
                    return;
                }
                const confirmed = res.find((a) => a && a.upload_record_id === uploadRecordId) || res[0];
                if (!confirmed)
                    return;
                const newAttachments = consultation.attachments.map((attachment) => {
                    if (attachment.upload_record_id === uploadRecordId) {
                        return confirmed;
                    }
                    return attachment;
                });
                consultation.attachments = newAttachments;
            });
        });
    }
    cancelAttachmentUpload(uploadRecordId, consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield livequeueConsultationService.cancelAttachmentUpload(uploadRecordId, consultationId);
        });
    }
    getAttachmentDownloadUrl(uploadRecordId, consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.getAttachmentDownloadUrl(uploadRecordId, consultationId);
            return res;
        });
    }
    createConsultation(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.createConsultation(payload);
            runInAction(() => {
                this.createdConsultation = res;
            });
        });
    }
    setIdentifiers(consultationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.setIdentifiers(consultationId, payload);
            runInAction(() => {
                this.createdConsultation = res;
            });
        });
    }
    setTelehealthAppointment(consultationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.setTelehealthAppointment(consultationId, payload);
            runInAction(() => {
                this.createdConsultation = res;
            });
        });
    }
    createAttachmentRequirement(consultationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.createAttachmentRequirement(consultationId, payload);
            return res;
        });
    }
    verifyAttachmentRequirement(consultationId, attachmentRequirementId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.verifyAttachmentRequirement(consultationId, attachmentRequirementId, payload);
            runInAction(() => {
                this.selectedConsultation = res;
            });
            return res;
        });
    }
    getServicesList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield livequeueConsultationService.getConsultationsServicesList(params);
            runInAction(() => {
                this.servicesListAll = res;
            });
        });
    }
}
const livequeueConsultationsStore = new LivequeueConsultationsStore();
export default livequeueConsultationsStore;
